import { getMenus } from '@/api/global';
import { INIT_MENUS } from '@/config';
import router from '@/router/index';
import { getAccount } from '@/utils/account';
import { getToken } from '@/utils/auth';

const menu = {
  namespaced: true,
  state: {
    menus: [...INIT_MENUS],
    isGetMenu: false,
    workPermission: false,
    authList: [],
  },
  getters: {
    menuList: (state) => state.menus,
    workPermission: (state) => state.workPermission,
  },
  actions: {
    async getMenus({ commit }) {
      try {
        const hasHomeWork = false;
        const res = await getMenus({ parentId: 4 });
        res.data = res.data || { menuTreeList: [], uiElementList: [] };
        res.data.menuTreeList = (res.data.menuTreeList || []).map((item) => {
          // if (item.menuCode === 'home') {
          //   hasHomeWork = true; // 存在工作台权限
          // }
          // 一级菜单图标写在code上（menuCode）如果一级菜单没有图标，默认pages-icon
          if (item.type === 'FIRST_LEVEL_MENU') {
            item.icon = item.menuCode || 'pages-icon';
          }
          return item;
        });
        res.data.uiElementList = res.data.uiElementList || [];
        const { menuTreeList = [], uiElementList = [] } = res.data;
        commit('SET_MENUS', { menus: menuTreeList, flag: hasHomeWork });
        commit('SET_AUTH_LIST', uiElementList);
        commit('SET_IS_GET_MENU', true);
      } catch (error) {
        // 获取菜单失败 清空菜单
        commit('SET_MENUS', { menus: [], flag: false });
        commit('SET_AUTH_LIST', []);
        commit('SET_IS_GET_MENU', false);
        console.log('getMenus error', error);
        setTimeout(() => {
          // 加setTimeout是需要等路由执行完后，宏任务执行完后，再执行下面的逻辑。否则会出现路由死循环
          if (error?.subCode === 'FORCE_MODIFY_PWD' && router.currentRoute.path !== '/changePassword' && getAccount() && getToken()) {
            // 非员工，密码过期
            router.replace({
              name: 'ChangePassword',
            });
          }
        });
      }
    },
  },
  mutations: {
    /**
     * 设置菜单
     *
     *  @param state
     *  @param {array} menus 菜单数据
     */
    SET_MENUS: (state, { menus, flag }) => {
      const menusList = flag ? [...menus] : [...INIT_MENUS, ...(menus || [])];
      state.menus = [...menusList];
      state.workPermission = flag;
    },
    SET_AUTH_LIST: (state, authList = []) => {
      state.authList = authList;
    },
    SET_IS_GET_MENU: (state, isGetMenu) => {
      state.isGetMenu = isGetMenu;
    },
  },
};

export default menu;
